import { render, staticRenderFns } from "./DialogOnePage.vue?vue&type=template&id=8955ff40"
import script from "./DialogOnePage.vue?vue&type=script&lang=js"
export * from "./DialogOnePage.vue?vue&type=script&lang=js"
import style0 from "./DialogOnePage.vue?vue&type=style&index=0&id=8955ff40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports